import React, { Component } from 'react';
import { isPasswordValid, validateEmail } from '../../../common/globalUtils';
import { Modal, ValidatedInput } from '../../shared-components';
import {
  EMAIL,
  EDIT_ACCOUNT_ACTION_TYPE, PASSWORD, DESIGNATION, NAME,
} from '../constants/UserManagementConstants';

import { t } from 'i18next';
import {
  ADD_USER_ACCOUNT_MODAL_I18N_KEYS as MY_I18N_KEYS,
  ADD_USER_ACCOUNT_MODAL_I18N_PREFIX,
} from './constants/i18n/AddUserAccountModali18nConstants';

const initialState = {
  name: '',
  email: '',
  password: '',
  designation: '',
  error: {},
  isSubmitting: false,
};
class AddUserAccountModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ...initialState,
    };
    this.setFormValue = this.setFormValue.bind(this);
  }

  getI18nAbsoluteKey(relativeKey) {
    return ADD_USER_ACCOUNT_MODAL_I18N_PREFIX  + "." + relativeKey;
  }

  getI18nText(relativeKey) {
    const absoluteKey = this.getI18nAbsoluteKey(relativeKey);
    return t(absoluteKey);
  }

  hasEmailBeenAddedBefore = (email, existingEmails) => {
    return existingEmails.find(e => e === email);
  };

  componentDidMount() {
    const { name, email, designation } = this.props.accountData;
    if (this.isEditAccountMode()) {
      this.setState({
        error: {},
        name: name,
        email: email,
        designation: designation,
      });
    } else {
      this.setState({
        error: {},
      });
    }
  }

  onClickSubmit = event => {
    this.setState({
      isSubmitting: true,
    });
    event.preventDefault();
    let { error, email, name, password, designation } = this.state;
    this.validateInputFields(error,email,password);
    const { toggleModal } = this.props;
    if (Object.keys(error).length === 0) {
      this.props.submit({
        email,
        name,
        password,
        designation,
      });
      error = {};
      if (this.isEditAccountMode()) {
        toggleModal(false);
      }
    }
    this.setState({
      error: error,
      isSubmitting: false,
    });
  };

validateInputFields = (error, email, password) => {
  const { accountData } = this.props;
  const existingEmails = this.props.accounts
    .map(e => e.email)
    .filter(e => e !== accountData.email);
  if (!validateEmail(email)) {
    error[EMAIL] = {
      isInvalid: true,
      message: this.getI18nText(MY_I18N_KEYS.invalid_email_format),
    };
  } else if (this.hasEmailBeenAddedBefore(email, existingEmails)) {
    error[EMAIL] = {
      isInvalid: true,
      message: this.getI18nText(MY_I18N_KEYS.email_already_exists),
    };
  }
  if ( !this.isEditAccountMode() && !isPasswordValid(password)) {
    error[PASSWORD] = {
      isInvalid: true,
      message: this.getI18nText(MY_I18N_KEYS.invalid_password)
    };
  }
}

  setFormValue = event => {
    let { error } = this.state;
    const key = event.target.name;
    const value = event.target.value;
    delete error[key];
    this.setState({
      [key]: value,
      error,
    });
  };

  renderAddNewAccountForm = () => {
    const { name, email, password, designation, error } = this.state;
    return (
      <form noValidate onSubmit={() => {}}>
        <ValidatedInput
          label={this.getI18nText(MY_I18N_KEYS.name_label)}
          name={NAME}
          value={name}
          onChange={this.setFormValue}
          isRequired={false}
          isInvalid={error[NAME]}
        />
        <ValidatedInput
          label={this.getI18nText(MY_I18N_KEYS.email_label)}
          name={EMAIL}
          value={email}
          onChange={this.setFormValue}
          isRequired={true}
          isInvalid={error[EMAIL] && error[EMAIL].isInvalid}
          message={error[EMAIL] && error[EMAIL].message}
        />
        { ! this.isEditAccountMode() && (
          <ValidatedInput
            label={this.getI18nText(MY_I18N_KEYS.password_label)}
            name={PASSWORD}
            value={password}
            onChange={this.setFormValue}
            isRequired={true}
            isInvalid={error[PASSWORD] && error[PASSWORD].isInvalid}
            message={error[PASSWORD] && error[PASSWORD].message}
            type={PASSWORD}
          />
        )}
        <ValidatedInput
          label={this.getI18nText(MY_I18N_KEYS.designation_label)}
          name={DESIGNATION}
          value={designation}
          onChange={this.setFormValue}
          isRequired={false}
          isInvalid={error[DESIGNATION]}
        />
      </form>
    );
  };

  onCloseResultModal = () => {
    this.props.toggleModal(false);
    this.props.toggleShowSubmitAddUserResult(false);
  };

  renderSubmitResult = () => {
    return (
      <div className="modal-dialog add-user-result">
        <div className="modal-content">
          <div className="title">
            <h5>{this.getI18nText(MY_I18N_KEYS.new_user_added_header)}</h5>
            <i className="la la-check icon" />
          </div>
          <div>
            <p>{this.getI18nText(MY_I18N_KEYS.new_user_add_paragraph_1)}</p>
            <p>{this.getI18nText(MY_I18N_KEYS.new_user_add_paragraph_2)}</p>
          </div>
          <button
            className={`btn btn-close`}
            onClick={() => {
              this.onCloseResultModal();
            }}
          >
            Close x
          </button>
        </div>
      </div>
    );
  };

  onClickCancelBtn = () => {
    this.setState(
      {
        error: {},
      },
      () => {
        this.props.toggleModal(false);
      },
    );
  };

  renderUpdateAccountDataBtn = () => {
    const { isSubmitting } = this.state;
    return (
      <div className="update-account">
        <button className={`btn btn-cancel `} onClick={this.onClickCancelBtn}>
          Cancel
        </button>
        <button className={`btn btn-submit`} onClick={this.onClickSubmit}>
          {isSubmitting && <i className="la la-spinner la-spin" />}Save
        </button>
      </div>
    );
  };

  renderAddAccountBtn = () => {
    const { isSubmitting } = this.state;
    return (
      <button className={`btn btn-submit btn-add-user`} onClick={this.onClickSubmit}>
        {isSubmitting && <i className="la la-spinner la-spin" />}
        {this.getI18nText(MY_I18N_KEYS.add_user)}
      </button>
    );
  };

  isEditAccountMode = () => {
    return this.props.type === EDIT_ACCOUNT_ACTION_TYPE;
  };

  renderAddUserContainer = () => {
    return (
      <div className="modal-dialog">
        <div className="modal-content">
          <h5 className="title">
            {this.isEditAccountMode() ? this.getI18nText(MY_I18N_KEYS.edit_user)
                                      : this.getI18nText(MY_I18N_KEYS.add_user) }
          </h5>
          {this.renderAddNewAccountForm()}
          {this.isEditAccountMode()
            ? this.renderUpdateAccountDataBtn()
            : this.renderAddAccountBtn()}
        </div>
      </div>
    );
  };

  render() {
    const { isShow } = this.props;
    const { isShowResult } = this.props;
    return (
      <Modal handleClick={() => this.onCloseResultModal()}>
        <div className={`add-user-modal modal ${isShow ? 'modal-show' : 'modal-hide'}`}>
          {isShowResult ? this.renderSubmitResult() : this.renderAddUserContainer()}
        </div>
      </Modal>
    );
  }
}

export default AddUserAccountModal;



// WEBPACK FOOTER //
// ./src/features/user-management/components/AddUserAccountModal.js